import { NamietkaKuGestorstvuApi } from 'elegislativa-frontend-ts-axios';
import { ClientResponse } from '../../model/ClientResponse';
import apiConfiguration from '../configuration/apiConfiguration';
import Uuid from '../../model/Uuid';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new NamietkaKuGestorstvuApi(apiConfiguration(elegislativaPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const namietkaKuGestorstvu = async (
  type: string,
  year: number,
  index: number,
  pracovnyKrokId: Uuid,
  namietka: string,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const { status } = await client.setNamietkaKuGestorstvu(type, year, index, pracovnyKrokId, { namietka }, headers);
  return { responseCode: status };
};
